// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3X-uo","vLegacy":"SelectSecondary_vLegacy__C9m3C","error":"SelectSecondary_error__2h7MC","disabled":"SelectSecondary_disabled__QR11S"};